/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinflyerfineprint2Inputs */

const en_checkinflyerfineprint2 = /** @type {(inputs: Checkinflyerfineprint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No app · no sign-up`)
};

const de_checkinflyerfineprint2 = /** @type {(inputs: Checkinflyerfineprint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohne App · ohne Anmeldung`)
};

/**
* | output |
* | --- |
* | "No app · no sign-up" |
*
* @param {Checkinflyerfineprint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinflyerfineprint2 = /** @type {((inputs?: Checkinflyerfineprint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinflyerfineprint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinflyerfineprint2(inputs)
	return de_checkinflyerfineprint2(inputs)
});
export { checkinflyerfineprint2 as "checkinFlyerFineprint" }